export const loanCalculatorData = [
  {
    id: 1,
    heading: "HDFC Car Loan EMI Calculator: Plan Your Car Loan with Ease",
    subHeading:
      "Use the Car Loan EMI Calculator to estimate your monthly installments and manage your car loan repayments effectively. Whether you&#39;re planning to buy a new or used car, our calculator gives you quick, precise EMI calculations to help you make informed borrowing decisions.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
